import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import useAuth from '../../auth/useAuth';
import { ROLES } from '../../config';
import Header from './Header';
import Footer from './Footer';

const DISTRIBUTOR_HOME = '/distribuidor';

// Layout de la tienda publica (cliente): header + contenido + footer. El distribuidor solo puede
// ver su lista de precios: cualquier otra pagina de la tienda (home, catalogo, carrito...) lo
// devuelve a /distribuidor.
export default function ClientLayout() {
  const { isInitialized, role } = useAuth();
  const { pathname } = useLocation();
  const isDistributor = role === ROLES.DISTRIBUIDOR;

  if (isInitialized && isDistributor && pathname !== DISTRIBUTOR_HOME) {
    return <Navigate to={DISTRIBUTOR_HOME} replace />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}
